import { Toaster as HotToaster } from 'react-hot-toast';
import { Toaster as SonnerToaster } from 'sonner';
import ModalProvider from '../Common/ModalProvider';
import ContactProvider from '../ContactPopup/ContactContext';

const Layout = ({ children }) => {
  return (
    <>
      <ContactProvider>
        {children}
        <ModalProvider />
      </ContactProvider>
      <HotToaster 
        position="bottom-right"
        toastOptions={{
          style: {
            background: '#ffffff',
            color: '#1A1F2C',
            border: '1px solid rgba(255, 20, 147, 0.1)',
            backdropFilter: 'blur(8px)',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
            fontWeight: 500,
          },
          success: {
            iconTheme: {
              primary: '#FF1493',
              secondary: '#ffffff',
            },
          },
          error: {
            iconTheme: {
              primary: '#ff4444',
              secondary: '#ffffff',
            },
          },
        }}
      />
      
      <SonnerToaster 
        position="bottom-right"
        theme="light"
        richColors
      />
    </>
  );
};

export default Layout; 